export enum SuggestType {
  CATEGORY = 'CATEGORY',
  QUERY = 'QUERY',
  BRAND = 'BRAND',
  MARKET = 'MARKET',
  EVENT = 'EVENT',
  LICENSED_IP = 'LICENSED_IP',
  OFFICIAL_MARKET = 'OFFICIAL_MARKET',
  SERVICE = 'SERVICE',
  DEEPLINK = 'DEEPLINK',
}

export const SUGGESTER_LINK_TEXT: Record<SuggestType, string | null> = {
  [SuggestType.CATEGORY]: '카테고리',
  [SuggestType.BRAND]: '브랜드',
  [SuggestType.MARKET]: '마켓',
  [SuggestType.EVENT]: '기획전',
  [SuggestType.LICENSED_IP]: '모아보기',
  [SuggestType.OFFICIAL_MARKET]: '바로가기',
  [SuggestType.SERVICE]: '서비스',
  [SuggestType.QUERY]: null,
  [SuggestType.DEEPLINK]: null,
};

export const toSuggestType = (value?: string): SuggestType | null => {
  if (!value) return null;

  return Object.values(SuggestType).includes(value as SuggestType)
    ? (value as SuggestType)
    : null;
};
